import { SaveFileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('SaveFile')
export class SaveFileConnectorProvider extends ConnectorProvider<SaveFileWorkflowNode> {}
